<p-toast></p-toast>

<p-popover #shipDatePanel>
    <p-datePicker [ngModel]="activeShipBlock?.shipDate" [inline]="true"
        (onSelect)="onShipDateSelect($event, shipDatePanel)" />
</p-popover>

<p-popover #arrivalDatePanel>
    <p-datePicker [ngModel]="activeArrivalBlock?.arrivalDate" [inline]="true"
        (onSelect)="onArrivalDateSelect($event, arrivalDatePanel)" />
</p-popover>

<p-popover #deliveryDatePanel>
    <p-datePicker [ngModel]="activeDeliveryBlock?.deliveryDate" [inline]="true"
        (onSelect)="onDeliveryDateSelect($event, deliveryDatePanel)" />
</p-popover>

<p-popover #estimatedDeliveryDatePanel>
    <p-datePicker [ngModel]="activeEstimatedDeliveryBlock?.estimatedDeliveryDate" [inline]="true"
        (onSelect)="onEstimatedDeliveryDateSelect($event, estimatedDeliveryDatePanel)" />
</p-popover>

<div class="bs-header">
    <div class="bs-header-left">
        <span class="bs-title">MV Power Stations</span>
        <span class="bs-divider-dot">•</span>
        <span class="bs-config-text">MV Power Station Configuration: {{ projectInfo.n1 || 0 }}-{{ projectInfo.n2 || 0 }}-{{ projectInfo.n3 || 0 }}-{{ projectInfo.n4 || 0 }}-{{ projectInfo.n5 || 0 }}-{{ projectInfo.n6 || 0 }}-{{ projectInfo.n7 || 0 }}</span>
        <span class="bs-divider-dot">•</span>
        <span class="bs-config-text">New MV Power Station Configuration: {{ newSkidConfig }}</span>
    </div>
    <div class="bs-header-actions">
          @if (canSave) {
            <button class="btn-outline" type="button" (click)="onSave()" [disabled]="saving || isReadOnly">
                <i class="ri-save-line"></i>
                <span>{{ saving ? 'Saving...' : 'Save' }}</span>
            </button>
        }
        @if (actionsMenu.length > 0) {
            <p-menu #menu [model]="actionsMenu" [popup]="true"></p-menu>
            <button class="btn-icon-only" type="button" (click)="menu.toggle($event)" pTooltip="Actions" tooltipPosition="left">
                <i class="ri-more-2-line"></i>
            </button>
        }     
       
    </div>
</div>

<p-table #dt [value]="filteredBlockScheduleList" [scrollable]="true" [scrollHeight]="tableScrollHeight"
    [virtualScroll]="true" [virtualScrollItemSize]="50"
    dataKey="blockScheduleId" [rowTrackBy]="trackByBlockScheduleId">
    <ng-template pTemplate="header">
        <tr>
            <th class="sticky-col sticky-col-select">
                <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAllChange($event)" [disabled]="permissions.isGridReadOnly || isReadOnly" class="native-checkbox" />
            </th>
            <th class="sticky-col sticky-col-1" style="min-width: 160px;">Shipping Date</th>
            <th class="sticky-col sticky-col-2" style="min-width: 160px;">Arrival Date</th>
            <th class="sticky-col sticky-col-3">TMEIC-Integrator Serial No.</th>
            <th style="min-width: 120px;">Customer MVPS #</th>
            <th style="min-width: 120px;">MVPS Configuration</th>
            <th style="min-width: 64px; text-align: center;">
                <button type="button" class="qr-header-button icon-only" (click)="downloadAllQrLabels($event)" pTooltip="Download all QR labels" tooltipPosition="top">
                    <span class="qr-download-icon" aria-hidden="true">
                        <i class="ri-qr-code-line qr-icon"></i>
                        <i class="ri-download-2-line download-icon"></i>
                    </span>
                </button>
            </th>
            <th style="min-width: 120px;">Bill of Lading</th>
            <th style="min-width: 160px;">Appointment Time</th>
            <th style="min-width: 120px;">Over Weight</th>
            <th style="min-width: 120px;">Over Dimension</th>
            <th style="min-width: 200px;">Logistics Comment</th>
            <th style="min-width: 160px;">Delivery Date</th>
            <th style="min-width: 150px;">Shipping Status</th>
            <th style="min-width: 200px;">Inverter 1 Serial No</th>
            <th style="min-width: 150px;">Inverter 1 IGBT</th>
            <th style="min-width: 200px;">Inverter 2 Serial No</th>
            <th style="min-width: 150px;">Inverter 2 IGBT</th>
            <th style="min-width: 200px;">Inverter 3 Serial No</th>
            <th style="min-width: 150px;">Inverter 3 IGBT</th>
            <th style="min-width: 200px;">Inverter 4 Serial No</th>
            <th style="min-width: 150px;">Inverter 4 IGBT</th>
            <th style="min-width: 200px;">Inverter 5 Serial No</th>
            <th style="min-width: 150px;">Inverter 5 IGBT</th>
            <th style="min-width: 200px;">Inverter 6 Serial No</th>
            <th style="min-width: 150px;">Inverter 6 IGBT</th>
            <th style="min-width: 200px;">Inverter 7 Serial No</th>
            <th style="min-width: 150px;">Inverter 7 IGBT</th>
            <th style="min-width: 120px;">SCU Installed?</th>
            <th style="min-width: 120px;">DIS Installed?</th>
            <th style="min-width: 150px;">EPANB Installed?</th>
            <th style="min-width: 150px;">DC Fuses Installed?</th>
            <th style="min-width: 160px;">Estimated Delivery Date</th>
            <th style="min-width: 150px;">MV Xfmr Design</th>
            <th style="min-width: 200px;">MV Xfmr #</th>
            <th style="min-width: 200px;">LV Xfmr #</th>
            <th style="min-width: 120px;">Bushing Size</th>
            <th style="min-width: 200px;">SCADA #</th>
            <th style="min-width: 200px;">Tracker #1</th>
            <th style="min-width: 180px;">Wildlife Repellent Added?</th>
            <th style="min-width: 220px;">Wildlife Warning Label Applied?</th>
            <th style="min-width: 250px;">Notes</th>
            <th style="min-width: 150px;">MVPS Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-block let-rowIndex="rowIndex">
        <tr [ngClass]="{'completed-row': block._isCompleted}">
            <td class="sticky-col sticky-col-select">
                <input type="checkbox" [(ngModel)]="block.selected" (change)="onRowSelectionChange()" [disabled]="permissions.isGridReadOnly || isReadOnly" class="native-checkbox" />
            </td>
            <td class="sticky-col sticky-col-1">
                <div class="date-field"
                    [ngClass]="{'date-field-disabled': !permissions.isAdmin || isReadOnly}"
                    (click)="permissions.isAdmin && !isReadOnly && onShipDateIconClick(block, $event, shipDatePanel)"
                    [style.cursor]="!permissions.isAdmin || isReadOnly ? 'not-allowed' : 'pointer'">
                    <span class="date-field-text" [ngClass]="{'weekend-date': block._isShipWeekend}">{{ block.shipDate | date:'MM/dd/yyyy' }}</span>
                    <i class="ri-calendar-line"></i>
                </div>
            </td>
            <td class="sticky-col sticky-col-2">
                <div class="date-field"
                    [ngClass]="{'date-field-disabled': !permissions.isAdmin || isReadOnly}"
                    (click)="permissions.isAdmin && !isReadOnly && onArrivalDateIconClick(block, $event, arrivalDatePanel)"
                    [style.cursor]="!permissions.isAdmin || isReadOnly ? 'not-allowed' : 'pointer'">
                    <span class="date-field-text" [ngClass]="{'weekend-date': block._isArrivalWeekend}">{{ block.arrivalDate | date:'MM/dd/yyyy' }}</span>
                    <i class="ri-calendar-line"></i>
                </div>
            </td>
            <td class="sticky-col sticky-col-3">
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.integratorSkidSerialNo" [disabled]="true" />
            </td>
            <td>
                <input
                    type="text"
                    class="p-inputtext w-full"
                    [ngModel]="getCustomerMvpsDisplay(block)"
                    (ngModelChange)="onCustomerMvpsChange(block, $event)"
                    [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <p-select [(ngModel)]="block.skidConfiguration" [options]="skidConfigOptions" [disabled]="isSkidConfigDisabled(block)" (onChange)="onSkidConfigurationChange(block)" appendTo="body" class="w-full" />
            </td>
            <td class="qr-cell">
                <button type="button" class="qr-download-button" (click)="downloadQrLabel(block, $event)" pTooltip="Download QR label" tooltipPosition="top">
                    <span class="qr-download-icon" aria-hidden="true">
                        <i class="ri-qr-code-line qr-icon"></i>
                        <i class="ri-download-2-line download-icon"></i>
                    </span>
                </button>
            </td>
            <!-- Logistics fields: Customer cannot edit -->
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.billoflading" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" />
            </td>
            <td>
                <p-datePicker [(ngModel)]="block.appointmentTime" [showIcon]="true" [timeOnly]="true" [iconDisplay]="'input'" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="checkbox" [(ngModel)]="block.overWeight" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" class="native-checkbox" />
            </td>
            <td>
                <input type="checkbox" [(ngModel)]="block.overDimension" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" class="native-checkbox" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.logisticsComment" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" />
            </td>
            <td>
                <div class="date-field"
                    [ngClass]="{'date-field-disabled': permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly}"
                    (click)="!(permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly) && onDeliveryDateClick(block, $event, deliveryDatePanel)"
                    [style.cursor]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly ? 'not-allowed' : 'pointer'">
                    <span class="date-field-text">{{ block.deliveryDate | date:'MM/dd/yyyy' }}</span>
                    <i class="ri-calendar-line"></i>
                </div>
            </td>
            <td>
                <p-select [(ngModel)]="block.shippingStatus" [options]="shippingStatusOptions" [disabled]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <!-- Inverter fields: Integrator cannot edit, also controlled by skid configuration -->
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv1SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv1Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv1Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv1Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv2SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv2Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv2Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv2Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv3SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv3Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv3Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv3Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv4SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv4Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv4Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv4Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv5SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv5Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv5Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv5Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv6SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv6Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv6Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv6Enabled" appendTo="body" class="w-full" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.inv7SerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv7Enabled" />
            </td>
            <td>
                <p-select [(ngModel)]="block.inv7Igbt" [options]="igbtOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly || !block._inv7Enabled" appendTo="body" class="w-full" />
            </td>
            <!-- Technical fields: Integrator cannot edit -->
            <td>
                <p-select [(ngModel)]="block.scu" [options]="installedOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <p-select [(ngModel)]="block.dis" [options]="installedOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <p-select [(ngModel)]="block.epanb" [options]="installedOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <p-select [(ngModel)]="block.dcFuses" [options]="installedOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <!-- Logistics field: Customer cannot edit -->
            <td>
                <div class="date-field"
                    [ngClass]="{'date-field-disabled': permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly}"
                    (click)="!(permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly) && onEstimatedDeliveryDateClick(block, $event, estimatedDeliveryDatePanel)"
                    [style.cursor]="permissions.isGridReadOnly || permissions.isIntegrator || isReadOnly ? 'not-allowed' : 'pointer'">
                    <span class="date-field-text">{{ block.estimatedDeliveryDate | date:'MM/dd/yyyy' }}</span>
                    <i class="ri-calendar-line"></i>
                </div>
            </td>
            <!-- Technical fields: Integrator cannot edit -->
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.mvXfmrDesign" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.mvXfmrSerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.lvXfmrSerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.bushingSize" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.scadaSerialNo" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <input type="text" class="p-inputtext w-full" [(ngModel)]="block.trackerSerialNo1" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" />
            </td>
            <td>
                <p-select [(ngModel)]="block.wildlifeRepellentAdded" [options]="wildlifeDeterrentOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <p-select [(ngModel)]="block.wildlifeWarningLabelApplied" [options]="wildlifeDeterrentOptions" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
            <td>
                <textarea class="p-inputtextarea w-full" [(ngModel)]="block.notes" rows="1" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly"></textarea>
            </td>
            <td>
                <p-select [(ngModel)]="block.skidStatus" [options]="skidStatusOptions" (onChange)="onSkidStatusChange(block)" [disabled]="permissions.isGridReadOnly || permissions.isUser || isReadOnly" appendTo="body" class="w-full" />
            </td>
        </tr>
    </ng-template>
</p-table>
